import React from 'react';

import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';

import Box from '@mui/material/Box';

import { Button } from 'components/Button';

import { useStore } from 'utils/hooks/store';

import { Header, Wrapper, UnsavedChanges } from './styles';
import { WrapperWithHeaderProps } from './types';

const WrapperWithHeader = ({
  title,
  helpCenterRedirect = false,
  unsavedChanges = false,
  children,
  flex,
  distance,
}: WrapperWithHeaderProps): React.ReactElement => {
  const {
    session: { user },
  } = useStore();

  const redirectToHelpCenter = (): void => {
    window.open(user?.helpCenterUrls.layoutEditorUrl, '_blank');
  };

  return (
    <Wrapper $flex={flex} $distance={distance}>
      <Header>
        <Box sx={{ display: 'flex' }}>
          <p>{title}</p>
          {unsavedChanges && <UnsavedChanges>Unsaved changes</UnsavedChanges>}
        </Box>
        {helpCenterRedirect && (
          <Button
            onClick={redirectToHelpCenter}
            variant="text"
            size="large"
            startIcon={<HelpOutlineOutlinedIcon />}
            style={{ paddingTop: 0, paddingBottom: 0, height: '100%' }}
          >
            Layout Editor Help
          </Button>
        )}
      </Header>
      {children}
    </Wrapper>
  );
};

export default WrapperWithHeader;
